import { useState } from 'react';
import styled, { css } from 'styled-components'
import toast from 'react-hot-toast';
import Api from '../utils/Api';
import UserCard from './UserCard';

const selectUserStyles = css`
display: flex;
flex-direction: column;
gap: 20px;
  & .users {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
`;
const SelectUser = styled(({ className, filter = {}, placeholder = 'Select user by name or email', onSelect }) => {
  const [shareWithEmail, setShareWithEmail] = useState('');
  const [users, setUsers] = useState([]);

  const fetchUsers = async email => {
    setShareWithEmail(email);
    if (email) {
      const [error, users] = await Api.getUserByEmail(email, filter);
      if (error) {
        toast.error(Api.error(error));
        console.error(error);
      } else {
        setUsers(users);
      }
    } else {
      setUsers([]);
    }
  }

  const handleSelectUser = user => {
    setUsers([]);
    setShareWithEmail('');
    onSelect(user);
  }

  const UserList = ({ users, onSelect }) => (
        users?.map(user =>
          <div key={user._id} onClick={() => onSelect(user)}>
            <UserCard key={user._id} user={user} />
          </div>)
  )
  return (
    <div className={className}>
      <input placeholder={placeholder} value={shareWithEmail} onChange={e => fetchUsers(e.target.value)} />
      {
        users.length ?
          <div className='users'>
            <UserList users={users} onSelect={handleSelectUser} />
          </div>
          : shareWithEmail
            ? <span>No user found</span>
            : null
      }
    </div>
  )
})`${selectUserStyles}`;

export default SelectUser;